// extracted by mini-css-extract-plugin
export default {"Testimonials":"Testimonials_Testimonials__bv0G6"};